import React from "react";
import styled from "styled-components";

// import Video from "./video";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Col, Row, Text, Img } from "../../comps";
import { Theme } from "../../theme/theme-provider";

import { roomLogo } from "../../theme/image";
import { serverDemoGif } from "../../theme/uploaded";
import {
  faCheck,
  faCommentDots,
  faHeadphonesAlt,
  faStream,
} from "@fortawesome/free-solid-svg-icons";
import { faSpotify } from "@fortawesome/free-brands-svg-icons";

const Wrapper = styled(Row)`
  width: 100%;
  min-width: 600px;
  margin-top: 30px;
  padding: 20px 20px;
  justify-content: space-between;
  align-items: center;
  /* box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.6); */
`;

const Details = styled(Col)`
  width: 50%;
`;

// const VideoWrapper = styled(Box)`
//   width: ${({ width }) => width};
//   height: ${({ height }) => height};
//   box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.6);
// `;

const Head = styled(Row)`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.BLUE_5};
`;

const TextContainer = styled(Row)`
  margin-top: 3px;
  padding: 0px 10px;
  align-items: center;
  color: ${({ theme }) => theme.textColor.light};
`;

const ListItem = ({ icon, text }) => {
  return (
    <TextContainer>
      <FontAwesomeIcon
        style={{
          fontSize: "20px",
          color: Theme.textColor.light,
          margin: "5px",
        }}
        icon={icon}
      />
      <Text
        fontFamily={Theme.fontFamily.grenze}
        fontWeight={500}
        color={Theme.textColor.light}
        fontSize="24px"
        textAlign="left"
        marginLeft="8px"
      >
        {text}
      </Text>
    </TextContainer>
  );
};

export default () => {
  // const videoWidth = 400;
  // const videoHeight = (9 * videoWidth) / 16;
  return (
    <Wrapper>
      <Details>
        <Col>
          <Head>
            <Text
              marginLeft="10px"
              fontFamily={Theme.fontFamily.grenze}
              fontWeight={600}
              fontSize="32px"
              color={Theme.color.BLUE_5}
              textAlign="left"
            >
              {"Rooms"}
            </Text>
            <Img
              style={{ marginLeft: "8px" }}
              src={roomLogo}
              width="40px"
              height="40px"
            />
          </Head>
          <ListItem
            text="Create rooms, invite friends and listen in sync"
            icon={faHeadphonesAlt}
          />
          <ListItem
            text="Import songs from spotify/youtube directly to room's queue"
            icon={faSpotify}
          />
          <ListItem text="Chat while listening" icon={faCommentDots} />
          <ListItem
            text="Unlike youtube, spotify... it's Ad free"
            icon={faCheck}
          />
          <ListItem
            text="Queue your favourite song or playlist"
            icon={faStream}
          />
        </Col>
      </Details>
      {/* <VideoWrapper width={videoWidth + "px"} height={videoHeight + "px"}>
        <Video videoId="ioNng23DkIM" />
      </VideoWrapper> */}
      <Img height="80%" src={serverDemoGif} />
    </Wrapper>
  );
};
